export default "__VITE_ASSET__BaK9H9YM__"